import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useEffect } from "react"
import { Appearance, ViewStyle } from "react-native"
import { JalaLoading, JalaWebView, LazyRender, Screen, Toast } from "../../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import { View } from "native-base"
import { translate } from "../../../../i18n"
import { color } from "../../../../theme"
import config from "../../../../utils/config"
import { goBack } from "../../../../navigators"
import { createAxios } from "../../../../utils/axios"


const ROOT: ViewStyle = {
  flex: 1,
}

const WEB_VIEW: ViewStyle = {
  flexGrow: 1,
}

const { BASE_URL } = config();

const LoadingState: FC<{ colorScheme: "light"|"dark" }> = function(props) {
  return (
    <View flex={1} px="16px" justifyContent="center" alignItems="center">
      <JalaLoading />
    </View>
  )
}

export const DiseaseDetailScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function DiseaseDetailScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route, navigation } = props

  useEffect(() => {
    dataToShare();
  }, [])

  useEffect(() => {
    createAxios().get('/ping')
      .catch((e) => {
        if (!Toast.isActive(e.name))
          Toast.show({ id: e.name, title: e.message })
        goBack('App.Stack')
      })
  }, [])

  const onError = useCallback(() => {
    goBack('App.Stack');
    Toast.show({ id: 'CanceledError', title: 'Request Timeout' })
  }, [])

  const dataToShare = () => {
    const diseaseName = route.params.data ? route.params.data.short_name : '-';
    // const mixpanelKey = "Mobile app: share post - detail disease";

    const title = translate('shareDiseaseTitle', { disease: diseaseName });
    const message = translate('checkLink', { url: `${BASE_URL}/diseases/` });
    const url = `${BASE_URL}/diseases/`
    const sharedData = { title, message, url }
    navigation.setParams({ sharedData })
  }

  const getUri = () => {
    const diseasesId = route.params.id ? route.params.id : '1';
    return `${BASE_URL}/web_view/diseases/${diseasesId}`;
  };

  const uri = getUri();

  return (
    <Screen
      style={ROOT}
      preset="fixed"
      unsafe
      colorScheme={colorScheme}
      backgroundBar={colorScheme === 'light' ? color.primary : undefined}
      statusBar={colorScheme === 'light' ? 'light-content' : 'dark-content'}
    >
      <LazyRender renderPlaceholder={LoadingState}>
        {uri && <JalaWebView
          source={{ uri }}
          style={WEB_VIEW}
          startInLoadingState
          onError={onError}
        />}
      </LazyRender>
    </Screen>
  )
})
